import React from "react";

/**
 * Official Cohnect symbol (the brand mark only, no wordmark) rendered as a
 * single-color inline SVG using currentColor so it can be tinted and used as a
 * faded decorative watermark that adapts to light/dark themes.
 * Shape: a bold "C" crescent opening right with a dot in the opening (the eye).
 */
export const CohnectMark = ({ className = "", style, title }) => (
  <svg
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    fill="currentColor"
    role={title ? "img" : undefined}
    aria-hidden={title ? undefined : "true"}
    aria-label={title}
  >
    <path
      fillRule="evenodd"
      d="M4 50 a46 46 0 1 0 92 0 a46 46 0 1 0 -92 0 Z M27 50 a33 33 0 1 0 66 0 a33 33 0 1 0 -66 0 Z"
    />
    <circle cx="64" cy="50" r="12" />
  </svg>
);
